module.exports = __webpack_public_path__ + "img/smile.fe6597f2.svg";